var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',{class:`${_vm.presenter.tagTextClass} mr-sm`},[_vm._v(_vm._s(_vm.presenter.tag))])])
}
var staticRenderFns = []

export { render, staticRenderFns }